import React from "react";
import Dropdown from "../DropDown";

interface BaseEntityDropdownProps {
  selectedBaseEntity: string;
  onBaseEntityChange: (selectedBaseEntity: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const BaseEntityDropdown: React.FC<BaseEntityDropdownProps> = ({
  selectedBaseEntity,
  onBaseEntityChange,
  className = "",
  disabled,
  onFocus,
}) => {

  const options = [
    { value: "power.vw_fact_fifteen_mins", label: "power.vw_fact_fifteen_mins" },
    { value: "power.vw_fact_five_mins", label: "power.vw_fact_five_mins" },
    { value: "power.vw_fact_daily_data", label: "power.vw_fact_daily_data" },
    { value: "power.vw_fact_hourly", label: "power.vw_fact_hourly" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedBaseEntity}
      onValueChange={onBaseEntityChange}
      disabled={disabled}
      className={className}
      placeholder="Select Base Entity"
      onFocus={onFocus}
    />
  );
};

export default BaseEntityDropdown;
